import type { CartData } from '@/lib/types';
import type { SubscriptionCode } from '@/state/subscription-codes';
import type { Subscription } from '@/state/subscription-groups';

export type SwitchDirection = 'upgrade' | 'downgrade' | 'same';

// Switching is a new purchase that replaces a membership whose payment failed.
// Every other status has its own door, so this one stays narrow on purpose.
export const canSwitchPlan = (subscriptionCode: SubscriptionCode): boolean =>
  subscriptionCode.status === 'PAST_DUE';

export const getSwitchDirection = (
  currentPrice: number | null,
  newPrice: number | null
): SwitchDirection => {
  const current = currentPrice ?? 0;
  const next = newPrice ?? 0;
  if (next > current) return 'upgrade';
  if (next < current) return 'downgrade';
  return 'same';
};

export const buildSwitchCart = (
  plan: Subscription,
  fromSubscriptionCodeId: string
): CartData<'subscription'> => ({
  items: [
    {
      ...plan,
      quantity: 1,
      price: plan.price ?? 0,
      switch_from_subscription_code_id: fromSubscriptionCodeId,
    },
  ],
  totalAmount: plan.price ?? 0,
  checkoutType: 'subscription',
});
